import React from "react";
import appTemplates from "appTemplates";
import { withRedux } from "helpers";
import { Background } from "components";
import Navigation from "./Navigation";
import { AppView, Button } from "appStyles";
import { Modal } from "@material-ui/core";
import StoreItemOrdering from "./StoreItemOrdering";
import CloseIcon from "@material-ui/icons/Close";
import RestoreFromTrashIcon from "@material-ui/icons/RestoreFromTrash";
import ShuffleIcon from "@material-ui/icons/Shuffle";
import styled from "react-emotion";
import Tooltip from "@material-ui/core/Tooltip";

const StoreItemContainer = styled("div")`
  border: 1px solid rgb(224, 224, 224);
  border-radius: 5px;
  padding: 12px;
  color: black;
  background-color: white;
  text-align: center;
  font-weight: normal;
  width: 100%;
  margin-bottom: 8px;
  cursor: pointer;

  &:hover,
  :focus {
    border: 1px solid white;
    opacity: 1;
    transition: opacity 0.4s;
    color: white;
    font-weight: bold;
    background-color: #89d2d3;
  }
`;

const IconContainer = styled("a")`
  cursor: pointer;
  transition: transform 0.2s ease-in-out;

  &:hover {
    transform: scale(1.2);
  }
`;

const AppViewContainer = styled("div")`
  width: 25em;
  height: 42em;
  max-height: 100%;
  /* border: 2px solid; */
  position: fixed;
  top: 4em;
  right: -1.9em;
  /* display: flex; */
  overflow-y: scroll;
  padding: 5px;
`;

const reorderText = "Reorder Store Items";
const trashText = "Deleted Items";

class AppViewComponent extends React.Component {
  renderTemplates(templateType) {
    if (templateType) {
      return appTemplates[templateType];
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      showStoreItemOrderingModal: false,
      showRetiredStoreItems: false,
    };

    this.toggleStoreItemOrderingModal =
      this.toggleStoreItemOrderingModal.bind(this);
  }

  toggleStoreItemOrderingModal() {
    let showStoreItemOrderingModal = this.state.showStoreItemOrderingModal;
    showStoreItemOrderingModal = !showStoreItemOrderingModal;
    this.setState({ showStoreItemOrderingModal });
  }

  toggleRetiredStoreItems() {
    let showRetiredStoreItems = this.state.showRetiredStoreItems;
    showRetiredStoreItems = !showRetiredStoreItems;
    this.setState({ showRetiredStoreItems });
  }

  isExpired(storeItem) {
    if (storeItem.expiration) {
      var expirationDate = new Date(storeItem.expiration);
      var now = new Date();
      if (expirationDate.getTime() < now.getTime()) {
        return true;
      }
    }
    return false;
  }

  onClick = (idx) => {
    let {
      actions: { updateActiveEditor },
    } = this.props;
    updateActiveEditor(idx);
  };

  renderRetiredItemsModal() {
    let { showRetiredStoreItems } = this.state;
    if (!showRetiredStoreItems) return null;

    const { store } = this.props;
    const retiredItems = [];
    Object.entries(store).forEach((storeItem) => {
      // console.dir(storeItem);
      if (storeItem[1].retired === 1 || this.isExpired(storeItem[1])) {
        // console.log(storeItem[1].id + ": " + storeItem[1].title);
        retiredItems.push(storeItem);
      }
    });
    retiredItems.reverse();

    return (
      <Modal
        open={showRetiredStoreItems}
        disableAutoFocus={true}
        onClose={() => this.toggleRetiredStoreItems()}
        style={{
          margin: "auto",
          width: "35%",
          top: "10%",
          left: "0%",
          overflowY: "auto",
          padding: "2em",
        }}
      >
        <div
          style={{
            backgroundColor: "white",
            height: "560px",
            padding: "20px",
            borderRadius: "5px",
          }}
        >
          <span
            style={{ cursor: "pointer" }}
            onClick={() => this.setState({ showRetiredStoreItems: false })}
          >
            <CloseIcon></CloseIcon>
          </span>
          <h3
            style={{
              padding: "8px",
              textAlign: "center",
            }}
          >
            Deleted items
          </h3>
          <div
            style={{
              justifyContent: "center",
              alignItems: "center",
              padding: "8px",
              overflowY: "scroll",
              height: "455px",
              border: "1px solid rgba(224,224,224,1)",
              borderRadius: "5px",
              backgroundColor: "white",
              transition: "background-color 0.2s ease",
              display: "inherit",
            }}
          >
            {retiredItems.map((storeItem) => {
              return (
                <StoreItemContainer
                  onClick={() => this.onClick(storeItem[1].id)}
                >
                  {storeItem[1].title}
                </StoreItemContainer>
              );
            })}
          </div>
        </div>
      </Modal>
    );
  }

  renderStoreItemOrderingModal() {
    let { showStoreItemOrderingModal } = this.state;
    if (!showStoreItemOrderingModal) return null;
    const { store } = this.props;

    return (
      <Modal
        open={showStoreItemOrderingModal}
        disableAutoFocus={true}
        // disableBackdropClick={isNewStoreItem}
        onClose={() => this.toggleStoreItemOrderingModal()}
        style={{
          margin: "auto",
          width: "35%",
          top: "1%",
          left: "0%",
          overflowY: "auto",
          padding: "1em",
        }}
      >
        <div
          style={{
            backgroundColor: "white",
            height: "530px",
            padding: "20px",
            borderRadius: "5px",
          }}
        >
          <span
            style={{ cursor: "pointer" }}
            onClick={() => this.setState({ showStoreItemOrderingModal: false })}
          >
            <CloseIcon></CloseIcon>
          </span>
          <StoreItemOrdering
            storeItems={store}
            closeModal={this.toggleStoreItemOrderingModal}
          />
        </div>
      </Modal>
    );
  }

  render() {
    const { activeTemplate, store } = this.props;
    const templateType = activeTemplate && activeTemplate.type;
    const isAtAboutUs = activeTemplate.type === "aboutUs";
    const isAtWebsite = activeTemplate.type === "website";
    const isAtStore = activeTemplate.type === "store";

    // console.dir(store);

    let liveStoreItems = 0;
    if (isAtStore) {
      Object.entries(store).forEach((storeItem) => {
        if (storeItem[1].retired === 0) {
          // not retired
          liveStoreItems++;
        }
      });
    }

    if (isAtWebsite) return null;
    return (
      <AppView
        className="appView"
        {...this.props}
        isAtStore={isAtStore}
        id="appView"
      >
        {!isAtAboutUs && (
          <p
            style={{
              position: "fixed",
              top: "-45px",
              textAlign: "center",
              fontSize: "12px",
              right: "8em",
            }}
          >
            Select components on the
            <br />
            preview to edit them!
          </p>
        )}
        <Background />
        <Navigation />
        {this.renderTemplates(templateType)}
        <div>
          {isAtStore &&
            Object.entries(store).length > 1 &&
            liveStoreItems >= 2 &&
            this.renderStoreItemOrderingModal()}
          {isAtStore &&
            Object.entries(store).length > 1 &&
            this.renderRetiredItemsModal()}
          {isAtStore && Object.entries(store).length > 1 ? (
            <div
              style={{
                padding: "10px",
                background: "#89d2d3",
                marginTop: "80px",
                // border: "1.5px solid black",
                borderRadius: "15px",
                color: "white",
                width: "60px",
                marginLeft: "auto",
                marginRight: " 35px",
                boxShadow: "rgb(120 120 120 / 50%) 6px 6px 13px",
                position: "fixed",
                top: "-79px",
                right: "-120px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {Object.entries(store).length > 1 && liveStoreItems >= 2 && (
                  <Tooltip title={reorderText}>
                    <IconContainer
                      onClick={() => this.toggleStoreItemOrderingModal()}
                    >
                      <ShuffleIcon fontSize={"large"}></ShuffleIcon>
                    </IconContainer>
                  </Tooltip>
                )}
                {Object.entries(store).length > 1 && (
                  <Tooltip title={trashText}>
                    <IconContainer
                      onClick={() => this.toggleRetiredStoreItems()}
                    >
                      <RestoreFromTrashIcon
                        fontSize={"large"}
                      ></RestoreFromTrashIcon>
                    </IconContainer>
                  </Tooltip>
                )}
              </div>
            </div>
          ) : null}
        </div>
      </AppView>
    );
  }
}

export default withRedux(AppViewComponent);
